<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
        <span class="breadcrumb m-0">
          <button class="btn btn-primary d-flex align-items-center" (click)="exportAll()">
            <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
          </button>

        </span>

      </div>
    </div>
  </div>

  <!-- <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <div class="page-title-right">
          <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
        </div>
      </div>
    </div>
  </div> -->



  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">


          <section class="">
            <div>

              <accordion [closeOthers]="false" class="accordion custom-accordian" [isAnimated]="true">
                <accordion-group [isOpen]="isAllOpen" heading="Additional Charges"
                  class="accordion-item mb-3 panel-open" #group>
                  <span accordion-heading class="float-end fs-5 d-flex align-items-center">

                    <i class="mdi font-size-24"
                      [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>
                  </span>
                  <ng-template #template let-anchor>
                    <span>{{ anchor.nativeElement.innerText }}</span>
                  </ng-template>

                  <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                    (mouseover)="showTooltip($event)">
                    <kendo-grid [data]="billSettinggridData" [pageSize]="pageSize" [skip]="skip" [sortable]="true"
                      [pageable]="{ 
                                            buttonCount: buttonCount,
                                            info: info,
                                            type: type,
                                            pageSizes: pageSizes,
                                            previousNext: previousNext
                                          }" [selectable]="selectableSettings" [reorderable]="true" filterable="menu"
                      [filter]="billsSettings.filter" [sort]="billsSettings.sort" [columnMenu]="{ filter: true }"
                      (filterChange)="onbillsFilterChange($event)" (sortChange)="onbillsSortChange($event)"
                      [resizable]="true" scrollable="scrollable" (pageChange)="PageChange($event)"
                      (selectionChange)="billsonSelectforBillSetting($event)"
                      (dataStateChange)="billStateChange($event)">

                      <ng-template kendoGridToolbarTemplate>
                        <!-- <kendo-textbox [style.width.px]="250" placeholder="Search in all columns..."
                              [(ngModel)]="searchedValue" (valueChange)="bilsonFilter($event)"></kendo-textbox> -->

                        <div class="search_icon">
                          <kendo-textbox [style.width.px]="250" [style.height.px]="35" [clearButton]="true"
                            (valueChange)="onValueChange($event)" (keydown.enter)="onSearchWalletSettings()"
                            [(ngModel)]="searchedValue" placeholder="Search in all columns...">
                          </kendo-textbox>

                          <button class="btn btn-primary btn-m border-left-none" (click)="bilsonFilter($event)">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                        <kendo-grid-spacer></kendo-grid-spacer>
                        <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
                          (click)="openChargeModel(addChargeModal)">Add Charges
                        </button>

                        <!-- <button class="btn btn-outline-primary btn-sm" (click)="billsSettingsExport('','Excel')">
                          <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                        </button> -->
                        <button class="btn btn-outline-primary btn-sm d-flex align-items-center" (click)="billsSettingsExport('','Excel')">
                          <span class="fas fa-file-excel"></span> &nbsp; Export to Excel
                        </button>
                        <!-- <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
                          (click)="onExport('Excel')">
                          <span class="fas fa-file-excel"> </span> &nbsp; Export to Excel
                        </button> -->
                        <!-- <button class="btn btn-light" (click)="onExport('Pdf')">
                            <span class="fas fa-file-pdf"> </span> &nbsp; Export to PDF</button> -->


                      </ng-template>

                      <!-- Pdf   start-->
                      <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                        <kendo-grid
                          [kendoGridBinding]="billselectedRowdata.length>0 ? billselectedRowdata:billSettinggridData.data"
                          #pdfGrid>
                          <kendo-grid-column field="name" title="Service Name"></kendo-grid-column>
                          <kendo-grid-column field="amount" title="Amount">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{ dataItem.charges.availableBalance | currency: 'INR':'symbol':'1.2-2' }}
                            </ng-template>
                          </kendo-grid-column>

                          <kendo-grid-column field="utility" title="Utility"></kendo-grid-column>
                          <kendo-grid-column field="charges.gstStatus" title="GST Applicable">
                          </kendo-grid-column>
                          <kendo-grid-column field="charges.createdOn" title="Created On" [width]="100">

                          </kendo-grid-column>
                          <kendo-grid-column field="charges.chargeApplicableDate" title="Deduction Date"
                            *ngIf="billingType !=='Postpaid'" [width]="90"></kendo-grid-column>
                            
                          <kendo-grid-column field="charges.gst" title="GST(%)"></kendo-grid-column>
                          
                          <kendo-grid-column field="charges.total" title="Total">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{ dataItem.availableBalance | currency: 'INR':'symbol':'1.2-2' }}
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-excel fileName="Bills Settings.xlsx"></kendo-grid-excel>
                        </kendo-grid>
                      </div>
                      <!-- Pdf Edrt-->
                      <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="20"
                        class="no-tooltip"></kendo-grid-checkbox-column>

                      <kendo-grid-column field="name" title="Name" [width]="100"></kendo-grid-column>
                      <kendo-grid-column field="utilityName" title="Utility" [width]="100"></kendo-grid-column>
                      <ng-template kendoGridDetailTemplate let-dataItem="dataItem">
                        <app-charge-expended [charges]="dataItem.charges"></app-charge-expended>
                      </ng-template>
                      <!-- <ng-template kendoGridDetailTemplate let-dataItem="dataItem">
                        
                        <app-wallet-history-expended [wallet]="dataItem.charges"></app-wallet-history-expended>
                      </ng-template> -->

                      <!--   <kendo-grid-column field="name" title="Name" [width]="200"></kendo-grid-column>
                      <ng-template kendoGridDetailTemplate let-dataItem="dataItem">
                        <app-multiflats-expended [flatsArry]="dataItem.charges"></app-multiflats-expended>
                      </ng-template>

                      <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                        class="no-tooltip"></kendo-grid-checkbox-column>
                      <kendo-grid-column field="amount" title="Amount" filter="numeric" [width]="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.amount | currency: 'INR':'symbol':'1.2-2' }}
                        </ng-template>
                      </kendo-grid-column>

                      <kendo-grid-column field="utility" title="Utility" [width]="100"></kendo-grid-column>
                      <kendo-grid-column field="isGSTApplicable" title="GST Applicable" filter="boolean" [width]="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.isGSTApplicable == true ? 'Yes' : 'No' }}

                        </ng-template>
                      </kendo-grid-column>

                      <kendo-grid-column field="chargeApplicableDate" title="Deduction Date"
                        *ngIf="billingType !=='Postpaid'" [width]="90"></kendo-grid-column>
                      <kendo-grid-column field="createdOn" title="Created On" filter="date" [width]="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{dataItem.createdOn | date: 'dd MMM yyyy'}}
                        </ng-template>  
                      </kendo-grid-column>

                      <kendo-grid-column field="gst" title="GST(%)" [width]="90" filter="numeric"></kendo-grid-column>
                      <kendo-grid-column field="total" title="Total" [width]="100" filter="numeric">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{ dataItem.total | currency: 'INR':'symbol':'1.2-2' }}
                        </ng-template>
                      </kendo-grid-column>

                      <kendo-grid-command-column title="" [columnMenu]="false" [width]="80">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="d-flex">
                           
                            <span kendoTooltip title="Go to Edit" (click)="editBillCharge(dataItem, addChargeModal)"
                              style="cursor: pointer;" class="me-3">
                              <i class="fas fa-edit text-primary"></i>
                            </span>

                           
                            <span kendoTooltip title="Delete" (click)="deletdBillCharge(dataItem)"
                              style="cursor: pointer;">
                              <i class="fas fa-trash-alt text-danger"></i>
                            </span>
                          </div>
                        </ng-template>
                      </kendo-grid-command-column> -->

                      <kendo-grid-command-column title="" [columnMenu]="false" [width]="60">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="d-flex">

                            <span kendoTooltip title="Go to Edit" (click)="editBillCharge(dataItem, addChargeModal)"
                              style="cursor: pointer;" class="me-3">
                              <i class="fas fa-edit text-primary"></i>
                            </span>


                            <span kendoTooltip title="Delete" (click)="deletdBillCharge(dataItem)"
                              style="cursor: pointer;">
                              <i class="fas fa-trash-alt text-danger"></i>
                            </span>
                          </div>
                        </ng-template>
                      </kendo-grid-command-column>
                    </kendo-grid>
                  </div>


                </accordion-group>

                @if(billingType=='Postpaid'){ <accordion-group [isOpen]="isAllOpen" heading="Optional"
                  class="accordion-item mb-3 panel-open" #item3>
                  <span accordion-heading class="float-end fs-5 d-flex align-items-center">

                    <i class="fas font-size-24"
                      [ngClass]="!item3?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>
                  </span>

                  <div class="col-lg-4">
                    <div class="mb-3">
                      <label for="basicpill-pancard-input"> </label>
                      <div>
                        <input class="form-check-input" type="checkbox" [(ngModel)]="isPenalityApplicable"
                          (ngModelChange)="onPenalityApplicableChange($event)" id="IsWalletEnabled">
                        <label class="form-check-label ms-2" for="IsWalletEnabled">Is penality applicable </label>
                      </div>
                    </div>
                  </div>

                  @if(this.billGenType?.toLowerCase() ==='individual' && isPenalityApplicable){
                 
                  <form action="" class="form-horizontal" [formGroup]="UtlityindividualbillForm">
                    <div class="row" formArrayName="gas_array">
                      <div *ngFor="let gas of gas_array.controls; let empIndex=index">
                        <div [formGroupName]="empIndex">
                          <div class="row">
                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality applicable date for gas <span class="required">*</span></label>
                                <ng-select [items]="projectBillingDates" formControlName="penaltyApplicable_dateGas"
                                  [placeholder]="'Select..'" [multiple]="false" [deselectOnClick]="true"></ng-select>


                                @if(gas.get('penaltyApplicable_dateGas')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(gas.get('penaltyApplicable_dateGas')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateGas}}</div>}
                                  @if(gas.get('penaltyApplicable_dateGas')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}


                              </div>
                            </div>

                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality amount for gas<span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="PenalityAmountForGas"
                                  placeholder="Enter Amount ">
                                @if(gas.get('PenalityAmountForGas')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(gas.get('PenalityAmountForGas')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenalityAmountForGas}}</div>}
                                  @if(gas.get('PenalityAmountForGas')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                  @if(gas.get('PenalityAmountForGas')?.errors?.['max']){
                                  <div>{{prifileValidations.billCharge.maxlimit}}</div>}

                                </div>}
                              </div>
                            </div>

                            <!-- 
                            <div class="col-lg-3 mb-3">
                              <div class="mb-3">
                                <label>Penality applicable date for others<span class="required">*</span></label>
                                <ng-select [items]="projectBillingDates" formControlName="PenaltyApplicable_dateOthers"
                                  [placeholder]="'Select..'" [multiple]="false" [deselectOnClick]="true"></ng-select>
                                @if(gas.get('PenaltyApplicable_dateOthers')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(gas.get('PenaltyApplicable_dateOthers')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateGas}}</div>}
                                  @if(gas.get('PenaltyApplicable_dateOthers')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}
                              </div>
                            </div>

                            <div class="col-lg-3 mb-3">
                              <div class="mb-3">
                                <label>Penality amount for others <span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Amount"
                                  formControlName="PenalityAmountForOthers">
                                @if(gas.get('PenalityAmountForOthers')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(gas.get('PenalityAmountForOthers')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateGas}}</div>}
                                  @if(gas.get('PenalityAmountForOthers')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}
                              </div>
                            </div> -->


                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- water -->
                    <div class="row" formArrayName="water_array">
                      <div *ngFor="let water of water_array.controls; let empIndex=index">
                        <div [formGroupName]="empIndex">
                          <div class="row">
                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality applicable date for water<span class="required">*</span></label>
                                <ng-select [items]="projectBillingDates" formControlName="PenaltyApplicable_dateWater"
                                  [placeholder]="'Select..'" [multiple]="false" [deselectOnClick]="true"></ng-select>
                                @if(water.get('PenaltyApplicable_dateWater')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(water.get('PenaltyApplicable_dateWater')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateWater}}</div>}
                                  @if(water.get('PenaltyApplicable_dateWater')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}
                              </div>
                            </div>

                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality amount for water <span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Amount"
                                  formControlName="PenalityAmountForWater">
                                @if(water.get('PenalityAmountForWater')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(water.get('PenalityAmountForWater')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenalityAmountForWater}}</div>}
                                  @if(water.get('PenalityAmountForWater')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                  @if(water.get('PenalityAmountForWater')?.errors?.['max']){
                                  <div>{{prifileValidations.billCharge.maxlimit}}</div>}

                                </div>}
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- eletricity -->
                    <div class="row" formArrayName="electricity_array">
                      <div *ngFor="let ele of electricity_array.controls; let empIndex=index">
                        <div [formGroupName]="empIndex">
                          <div class="row">

                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality applicable date for electricity <span class="required">*</span></label>
                                <ng-select [items]="projectBillingDates" [placeholder]="'Select..'"
                                  formControlName="PenaltyApplicable_dateElectricity" [multiple]="false"></ng-select>
                                @if(ele.get('PenaltyApplicable_dateElectricity')?.invalid &&
                                optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(ele.get('PenaltyApplicable_dateElectricity')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateElectricity}}</div>}
                                  @if(ele.get('PenaltyApplicable_dateElectricity')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}
                              </div>
                            </div>
                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality amount for electricity <span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Amount"
                                  formControlName="PenalityAmountForElectricity">
                                @if(ele.get('PenalityAmountForElectricity')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(ele.get('PenalityAmountForElectricity')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenalityAmountForElectricity}}</div>}
                                  @if(ele.get('PenalityAmountForElectricity')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                  @if(ele.get('PenalityAmountForElectricity')?.errors?.['max']){
                                  <div>{{prifileValidations.billCharge.maxlimit}}</div>}
                                </div>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- triSources -->
                    <div class="row" formArrayName="triSource_array">
                      <div *ngFor="let ele of triSource_array.controls; let empIndex=index">
                        <div [formGroupName]="empIndex">
                          <div class="row">

                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality applicable date for triSources <span class="required">*</span></label>
                                <ng-select [items]="projectBillingDates" [placeholder]="'Select..'"
                                  formControlName="PenaltyApplicable_dateTriSources" [multiple]="false"></ng-select>
                                @if(ele.get('PenaltyApplicable_dateTriSources')?.invalid &&
                                optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(ele.get('PenaltyApplicable_dateTriSources')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenaltyApplicable_dateElectricity}}</div>}
                                  @if(ele.get('PenaltyApplicable_dateTriSources')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                </div>}
                              </div>
                            </div>
                            <div class="col-lg-5">
                              <div class="mb-3">
                                <label>Penality amount for triSources <span class="required">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Amount"
                                  formControlName="PenalityAmountForTriSources">
                                @if(ele.get('PenalityAmountForTriSources')?.invalid && optionalSubmitted){
                                <div class="invalid-feedback">
                                  @if(ele.get('PenalityAmountForTriSources')?.errors?.['required']){
                                  <div>{{prifileValidations.billCharge.PenalityAmountForElectricity}}</div>}
                                  @if(ele.get('PenalityAmountForTriSources')?.errors?.['pattern']){
                                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                                  @if(ele.get('PenalityAmountForTriSources')?.errors?.['max']){
                                  <div>{{prifileValidations.billCharge.maxlimit}}</div>}
                                </div>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- other Amount  -->
                    <div class="row">
                      <div class="col-lg-5">
                        <div class="mb-3">
                          <label>Penality applicable date for others<span class="required">*</span></label>
                          <ng-select [items]="projectBillingDates" formControlName="PenaltyApplicable_dateOthers"
                            [placeholder]="'Select..'" [multiple]="false" [deselectOnClick]="true"></ng-select>
                          @if(optionalSubmitted && optionalbillsControls['PenaltyApplicable_dateOthers'].errors){
                          <div class="invalid-feedback">
                            @if(optionalbillsControls['PenaltyApplicable_dateOthers'].errors['required']){
                            <div>{{prifileValidations.billCharge.PenaltyApplicable_dateOthers}}</div>}

                          </div>}
                        </div>
                      </div>

                      <div class="col-lg-5">
                        <div class="mb-3">
                          <label>Penality amount for others <span class="required">*</span></label>
                          <input type="text" class="form-control" placeholder="Enter Amount"
                            formControlName="PenalityAmountForOthers">
                          @if(optionalSubmitted && optionalbillsControls['PenalityAmountForOthers'].errors){
                          <div class="invalid-feedback">
                            @if(optionalbillsControls['PenalityAmountForOthers'].errors['required']){
                            <div>{{prifileValidations.billCharge.PenalityAmountForOthers}}</div>}
                            @if(optionalbillsControls['PenalityAmountForOthers'].errors['pattern']){
                            <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                            @if(optionalbillsControls['PenalityAmountForOthers'].errors['max']){
                            <div>{{prifileValidations.billCharge.maxlimit}}</div>}
                          </div>}
                        </div>
                      </div>
                    </div>

                  </form>
                  }
                  @else if(isPenalityApplicable){
                  <form [formGroup]="combinedBillForm">
                    <div class="row">
                      <div class="col-lg-3 mb-3">
                        <div class="mb-3">
                          <label>Penality applicable Date <span class="required">*</span> </label>
                          <ng-select [items]="projectBillingDates" formControlName="date" id="billDate"
                            [multiple]="false"></ng-select>
                          @if(individualbillSubmitted &&
                          combinedBillFormControls['date'].errors){
                          <div class="invalid-feedback">
                            @if(combinedBillFormControls['date'].errors['required']){
                            <div>{{prifileValidations.billCharge.Penalitydate}}</div>}
                          </div>}
                        </div>
                      </div>
                      <div class="col-lg-3 mb-3">
                        <label>Penality Amount <span class="required">*</span></label>
                        <input type="text" class="form-control" placeholder="Enter Amount" formControlName="amount">
                        @if(individualbillSubmitted &&
                        combinedBillFormControls['amount'].errors){
                        <div class="invalid-feedback">
                          @if(combinedBillFormControls['amount'].errors['required']){
                          <div>{{prifileValidations.billCharge.PenalityAmount}}</div>}
                          @if(combinedBillFormControls['amount'].errors['pattern']){
                          <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                          @if(combinedBillFormControls['amount'].errors['max']){
                          <div>{{prifileValidations.billCharge.maxlimit}}</div>}
                        </div>}
                      </div>

                    </div>
                  </form>
                  }

                  <ul class="list-inline wizard d-flex justify-content-end mt-4">
                    <!-- <li class="previous list-inline-item" aria-disabled="true"><button class="btn btn-outline-primary"
                                        cdkStepperPrevious>Previous</button></li>
                                     -->
                    <li class="next list-inline-item" aria-disabled="false"><button class="btn btn-primary"
                        (click)="saveOptionalfrom()">Save</button></li>
                    <!-- <li class="next list-inline-item" aria-disabled="false"><button class="btn btn-primary"
                            cdkStepperNext>Next</button></li> -->
                  </ul>
                </accordion-group>}
              </accordion>
            </div>

          </section>



        </div>
      </div>
    </div>
  </div>
</div>


<!-- Add Charge modal -->
<ng-template #addChargeModal>
  <div class="modal-lg ">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        @if(billChargeId) { <h5 class="modal-title">Edit Charge</h5>}
        @else {<h5 class="modal-title">Add Charges</h5>}
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeChargeModal()"></button>
      </div>
      <div class="modal-body">

        <!--  <form [formGroup]="billsChargeForm">
          <div class="row">

            <div class="col-lg-6 mb-3">
              <label>Service Name <span class="required">*</span></label>
              <input type="text" placeholder="Enter Name" formControlName="name" class="form-control" />
              @if(submitted && billsControls['name'].errors){
              <div class="invalid-feedback">
                @if(billsControls['name'].errors['required']){
                <div>{{prifileValidations.billCharge.name}}</div>}
                @if(billsControls['name'].errors['pattern']){
                <div>{{prifileValidations.billCharge.OnlyAlphanumeric_patten}}</div>}



              </div>}
            </div>

            <div class="col-lg-6 mb-3">
              <label>Amount <span class="required">*</span></label>
              <input type="text" placeholder="Enter Amount" (keyup)="onFocusOutAmount($event)" formControlName="amount"
                class="form-control" />
              @if(submitted && billsControls['amount'].errors){
              <div class="invalid-feedback">
                @if(billsControls['amount'].errors['required']){
                <div>{{prifileValidations.billCharge.amount}}</div>}
                @if(billsControls['amount'].errors['pattern']){
                <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>}
                @if(billsControls['amount'].errors['max']){
                <div>{{prifileValidations.billCharge.maxlimit_amount}}</div>}
              </div>}
            </div>

            <div class=" col-lg-6 mb-3">
              <label>Utility</label>
              <ng-select [items]="filteredUtilityList" formControlName="utilityType" id="ocupantName" name="ocupantName"
                (change)="utilityChange($event)" [multiple]="false" bindLabel="name" bindValue="id"
                [placeholder]="'Select...'"></ng-select>

            </div>
            <div class="col-lg-6 mb-3" *ngIf="billingType !=='Postpaid'">
              <label for="basicpill-pancard-input">Select deduction date </label>
              <ng-select [items]="projectBillingDates"  (change)="deductionDate($event)"
                formControlName="chargeApplicableDate" id="billDate" [searchable]="false" [multiple]="false"></ng-select>

            </div>
            <div class="col-lg-6 mt-4">
              <input class="form-check-input" type="checkbox" (change)="onCheckboxChange($event)"
                formControlName="GST_Applicable" id="formCheck1">
              <label class="form-check-label" for="formCheck1"> &nbsp; GST Applicable</label>

            </div>
            @if(billsControls['GST_Applicable'].value == true ){
            <div class="col-lg-6 mb-3">
              <label>GST(%)<span class="required">*</span></label>
              <input type="text" placeholder="Enter GST" formControlName="gst" class="form-control"
                (keyup)="onFocusOut($event)">
              @if(submitted && billsControls['gst'].errors){
              <div class="invalid-feedback">
                @if(billsControls['gst'].errors['required']){
                <div>{{prifileValidations.billCharge.gst}}</div>}
                @if(billsControls['gst'].errors['pattern']){
                <div>{{prifileValidations.billCharge.patten}}</div>}
                <div *ngIf="billsControls['gst'].errors['max']">
                  GST percentage cannot exceed 28%.
                </div>
              </div>}
            </div>
            }
            <div class="col-lg-6 mb-3">
              <label>Total <span class="required">*</span></label>
              <input type="text" formControlName="total" class="form-control" />
              @if(submitted && billsControls['total'].errors){
              <div class="invalid-feedback">
                @if(billsControls['total'].errors['required']){
                <div>{{prifileValidations.billCharge.total}}</div>}

              </div>}
            </div>

          </div>
        </form>-->

        <!--  new Form Array  -->
        <form [formGroup]="form">

          <div class="row">

            <div class="col">
              <label>Service Name <span class="required">*</span></label>
              <input class="form-control" formControlName="name">

              <div class="text-danger" *ngIf="submitted && form.get('name')?.errors">

                <div *ngIf="form.get('name')?.errors?.['required']">
                  {{ prifileValidations.billCharge.name }}
                </div>


                <div *ngIf="form.get('name')?.errors?.['pattern']">
                  {{prifileValidations.billCharge.OnlyAlphanumeric_patten}}
                </div>

                <div *ngIf="form.get('name')?.errors?.['maxlength']">
                  {{ prifileValidations.billCharge.maxNameLength }}
                </div>

                <div *ngIf="form.get('name')?.errors?.['whitespace']">
                  Service name cannot be empty spaces only.
                </div>

              </div>
            </div>


            <div class="col">
              <label>Utility </label>
              <ng-select [items]="filteredUtilityList" formControlName="utilityId" id="utilityId" name="utilityId"
                (change)="utilityChange($event)" [multiple]="false" bindLabel="name" bindValue="id"
                [placeholder]="'Select...'"></ng-select>

            </div>

            <div class="col-2">
         <div class="mt-4 pt-1">
      
              <button class="btn btn-lg btn-primary" type="button" (click)="addRow()">+ Add</button>
            </div>
            </div>
          </div>

          <hr>

          <div formArrayName="charges">

            <div *ngFor="let row of charges.controls; let i = index" [formGroupName]="i" class="row mb-3">

              <div class="col-2">
                <label>SqFt Min <span class="required">*</span></label>
                <input class="form-control" formControlName="sqftMin" (input)="charges.updateValueAndValidity()">
                @if((submitted || row.get('sqftMin')?.touched) &&row.get('sqftMin')?.errors) {

                <div class="invalid-feedback">
                  @if(row.get('sqftMin')?.errors?.['required']) {
                  <div>SqFt Min Required</div>
                  }
                  @if(row.get('sqftMin')?.errors?.['pattern']) {
                  <div>Only positive whole numbers are allowed</div>
                  }
                   @if(row.get('sqftMin')?.errors?.['max']) {
                  <div>SqFt Min cannot exceed 100000000</div>
                  }
                </div>
                }
                <div class="text-danger" *ngIf="row.get('sqftMin')?.errors?.['notSequential']">
                  Must match previous Max value
                </div>
              </div>

              <div class="col-2">
                <label>SqFt Max<span class="required">*</span></label>
                <input class="form-control" formControlName="sqftMax" (input)="charges.updateValueAndValidity()">

                @if((submitted || row.get('sqftMax')?.touched) &&
                row.get('sqftMax')?.errors) {
                <div class="invalid-feedback">
                  @if(row.get('sqftMax')?.errors?.['required']) {
                  <div>SqFt Max Required</div>
                  }
                  @if(row.get('sqftMax')?.errors?.['pattern']) {
                  <div>Only positive whole numbers are allowed</div>
                  }
                  @if(row.get('sqftMax')?.errors?.['max']) {
                  <div>SqFt Max cannot exceed 10,00,00,000</div>
                  }
                </div>

                }

                <div class="text-danger" *ngIf="row.errors?.['minGreaterOrEqualMax']">
                  Max must be greater than Min
                </div>
              </div>

              <div class="col-2">
                <label>Amount <span class="required">*</span></label>
                <input class="form-control" formControlName="amount" (keyup)="onFocusOutAmount_new($event,row)">
                @if((submitted || row.get('amount')?.touched) &&
                row.get('amount')?.errors) {
                <div class="invalid-feedback">
                  @if(row.get('amount')?.errors?.['required']) {
                  <div>{{prifileValidations.billCharge.amount}}</div>
                  }
                  @if(row.get('amount')?.errors?.['pattern']) {
                  <div>{{prifileValidations.billCharge.Onlynumberwithdecimals}}</div>
                  }
                  @if(row.get('amount')?.errors?.['max']) {
                  <div>{{prifileValidations.billCharge.maxlimit_amount}}</div>
                  }
                </div>
                }

              </div>


              <div class="col-2">
                <input class="form-check-input" type="checkbox" (change)="onCheckboxChange_new($event,row)"
                  formControlName="isGSTApplicable" [id]="'gstCheckbox_' + i">
                <label class="form-check-label" [for]="'gstCheckbox_' + i"> &nbsp; GST Applicable</label>
                   @if(row.get('isGSTApplicable')?.value == true ){
              <div>
                <!-- <label>GST % <span class="required">*</span></label> -->
                <input class="form-control mt-2" formControlName="gst" (input)="calculateRowTotal(row)" placeholder="* Enter GST %">

                @if((submitted || row.get('gst')?.touched) &&
                row.get('gst')?.errors) {
                <div class="invalid-feedback">
                  @if(row.get('gst')?.errors?.['required']) {
                  <div>{{prifileValidations.billCharge.gst}}</div>
                  }
                  @if(row.get('gst')?.errors?.['pattern']) {
                  <div>{{prifileValidations.billCharge.patten}}</div>
                  }
                  @if(row.get('gst')?.errors?.['max']) {
                  <div>GST percentage cannot exceed 28%.</div>
                  }

                </div>
                }
              </div>
              
              }
              </div>

           


              <div class="col-2" *ngIf="billingType !=='Postpaid'">
                <label for="basicpill-pancard-input">deduction date </label>
                <ng-select [items]="projectBillingDates" (change)="deductionDate($event)" [searchable]="false" 
                  formControlName="chargeApplicableDate" id="billDate" [multiple]="false" [clearable]="!!row.get('chargeApplicableDate')?.value"></ng-select>
              </div>


              <div class="col-2">
                <div class="d-flex gap-2">
                <div>
                <label>Total <span class="required">*</span></label>
                <input class="form-control" formControlName="total">
             </div>
<div class="pt-4">
                   <button
                      type="button"
                      class="btn btn-md btn-danger mt-1"
                      *ngIf="charges.length > 1"
                      (click)="removeRow(i)"
                    >
                      <i class="fas fa-trash-alt text-white"></i>
                    </button>
              </div>
              </div>
</div>
            </div>

          </div>

          <!-- <hr> -->
        </form>


      </div>
      <div class="modal-footer">
        @if(billChargeId){ <button type="button" class="btn btn-primary waves-effect waves-light"
          (click)="saveCharge('update')">Update</button>}
        @else {<button type="button" class="btn btn-primary waves-effect waves-light"
          (click)="saveCharge('Create')">Save</button>}
      </div>
    </div>
  </div>

</ng-template>
<!-- Add Charge modal End  -->

